import { defineStore } from "pinia";
import type { IOffcanvasConfig } from "@/views/OffcanvasViews/OffcanvasViewsConfig";

export const useOffcanvasStore = defineStore("offcanvas", {
  state: (): { config: IOffcanvasConfig | null; history: IOffcanvasConfig[] } => ({
    config: null,
    history: [],
  }),
  persist: true,
  actions: {
    save(config: IOffcanvasConfig) {
      this.history.push(config);
      this.config = config;
    },
    clear() {
      this.config = null;
      this.history = [];
    },
    popHistory() {
      const last = this.history.pop();
      if (last) {
        this.config = this.history[this.history.length - 1] || null;
      }
    },
  },
});
